import styled from "styled-components";

export const PayslipDetailsModalWrapper = styled("div")(() => {
  return {
    overflow: "hidden",
    backgroundColor: "var(--color-background)",
    padding: 0,
    "& span": {
      display: "inline-block",
      width: "100%",
    },
    "& .firstContainer": {
      alignItems: "center",
      gap: "calc(var(--flexGap)/2)",
      padding: "calc(var(--cardPadding)/4) var(--cardPadding)",
      "& .button": {
        display: "none",
      },
      "& .first-container-item": {
        overflow: "hidden",
        width: "100%",
        "& h1": {
          // style the h1 to be alot smaller (fontsize)
          fontSize: "1.5rem",
          fontWeight: "700",
          marginBlock: 0,
        },
        "& h2": {
          // style the h1 to be alot smaller (fontsize)
          fontWeight: "500",
          marginBlock: 0,
        },
        "& h3": {
          // style the h1 to be alot smaller (fontsize)
          fontWeight: "500",
          marginBlock: 0,
        },
        "& .full-name": {
          flex: 1,
        },
        "& .date": {
          flex: 1,
        },
        "& .companyName": {
          flex: 1,
          textAlign: "right",
        },
      },
      "@media screen and (max-width: 1024px)": {
        alignItems: "flex-start",
        gap: "calc(var(--flexGap)/4)",
        flexDirection: "column-reverse",
      },
      "@media screen and (max-width: 766px)": {
        "& .button-div": {
          display: "none",
        },
      },
    },
    "& .heading-row": {
      padding: "var(--cardPadding)",
      "& h3": {
        marginBlock: 0,
        fontWeight: 600,
      },
    },
    "& .employee-information-block": {
      gap: "0.15rem",
      padding: "0 var(--cardPadding) var(--cardPadding) var(--cardPadding)",
      "& .employee-information": {
        flexDirection: "column",
        gap: "0.1rem",
        "& span": {
          display: "inline-block",
          width: "100%",
        },
        "@media screen and (min-width: 615px)": {
          flexDirection: "row",
          gap: "calc(var(--flexGap)/1)",
          "& div:nth-of-type(1)": {
            flex: 0.3,
            overflow: "hidden",
          },
          "& div:nth-of-type(2)": {
            flex: 0.7,
            overflow: "hidden",
          },
        },
      },
    },
    "& .user-summary-table": {
      overflow: "auto",
      marginBlockEnd: "var(--cardPadding)",
      padding: "0 var(--cardPadding)",
      "& th": {},
    },
    "& .table-footer": {
      padding: "0 calc(var(--cardPadding) /2)",
      border: "1px solid var(--color-primary-hover)",
      borderRadius: ".5rem",
      "& .table-footer-title": {
        flex: 1,
        "& h3": {
          minWidth: "230px",
        },
      },
      "& .table-footer-value": {
        flex: 1,
        "& h3": {
          minWidth: "230px",
          paddingInlineStart: "calc(var(--cardPadding) /2)",
        },
      },
    },
    "& th": {
      color: "var(--color-primary)",
      background: "var(--color-primary-hover)",
      minWidth: "150px",
      fontSize: "18px",
    },
    "& td": {
      minWidth: "200px",
    },
    "& .net-payable-summary": {
      padding: "0 var(--cardPadding) var(--cardPadding) var(--cardPadding)",
      "& .net-payable-summary-row": {
        border: "1px solid var(--color-primary-hover)",
        borderRadius: "1rem",
        overflow: "hidden",
        "& .net-payable-description": {
          padding: "calc(var(--cardPadding)/2)",
          overflow: "hidden",
          flex: 0.7,
          "& h3": {
            margin: 0,
          },
          "& p": {
            margin: 0,
          },
        },
        "& .net-payable-amount": {
          padding: "calc(var(--cardPadding)/2)",
          overflow: "hidden",
          color: "var(--color-primary)",
          backgroundColor: "var(--color-primary-hover)",
          flex: 0.3,
          textAlign: "center",
          "& h3": {
            fontWeight: 700,
            fontSize: "2rem",
            margin: 0,
          },
        },
        "@media screen and (max-width: 615px)": {
          flexDirection: "column",
          gap: "0",
        },
      },
    },
    " .middleContainer": {
      backgroundColor: "var(--color-primary-hover)",
      padding: "calc(var(--cardPadding)/1.5) var(--cardPadding)",
      "& .middle-container-column": {
        gap: "calc(var(--flexGap)/4)",
        flex: 1,
        overflow: "hidden",
        "& h3": {
          marginBlock: 0,
        },
        "& .span": {
          fontWeight: "600",
        },
      },
      "@media screen and (max-width: 1720px)": {
        flexDirection: "column",
      },
    },
    " .card": {
      backgroundColor: "var(--color-background)",
      flex: "1",
      borderRadius: ".5rem",
      padding: ".75rem",
    },
    "& .cardRow": {
      gap: "calc(var(--flexGap)/2)",
      "& div": {
        flex: 1,
        overflow: "hidden",
      },
      "@media screen and (max-width: 350px)": {
        flexDirection: "column",
        gap: "calc(var(--flexGap)/4)",
        "& div:nth-child(2)": {
          textAlign: "left !important",
        },
      },
    },
    "& .cardRow > div:nth-child(2)": {
      textAlign: "right",
    },
    "& .bottomContainer": {
      padding: "calc(var(--cardPadding)/1.5) var(--cardPadding)",
      alignItems: "center",
      "& h2": {
        fontWeight: "450",
        fontSize: 20,
        marginBlock: 0,
      },
      "& .bottom": {
        fontWeight: "700",
      },
      "& >*": {
        width: "100%",
      },
      ".amount": {
        backgroundColor: "var(--color-primary-hover)",
        borderRadius: ".3rem",
        padding: "calc(var(--cardPadding)/4)",
        boxSizing: "border-box",
      },
      "@media screen and (max-width: 1024px)": {
        alignItems: "flex-start",
        gap: "calc(var(--flexGap)/4)",
        flexDirection: "column",
      },
    },
    "& .close-modal-button-header": {
      padding: "calc(var(--cardPadding)/1.5)",
      "& .close-modal-button-area": {
        overflow: "hidden",
        "& .close-modal-button": {
          width: "fit-content",
          padding: "calc(var(--cardPadding)/4) calc(var(--cardPadding)/2)",
        },
        "@media screen and (min-width: 768px)": {
          display: "none",
        },
      },
    },
  };
});
